<template>
    <div class="form-input form-input-select-countries">
        <div class="form-input-header">
            <div class="label">{{ label }}</div>
            <div v-if="note" class="note">{{ note }}</div>
        </div>
        <div class="form-input-field">
            <vue-multi-select
                :selectOptions="regions"
                search
                :disabled="disabled && !regions.length"
                :multiple="true"
                :btnLabel="btnLabel"
                track-by="value"
                :options="{
                    multi: true,
                    labelSelected: 'selected',
                    cssSelected: (option) => ''
                }"
                :value="value"
                @input="setRegioncodes"
            >
                <template v-slot:option="{ option }">
                    <input type="checkbox" class="form-input-checkbox" :checked="option.selected"/>
                    <span v-if="option.name === $t('general.form.no_region')" :class="{ bold: option.selected }">{{ $t('general.form.no_region_title') }}</span>
                    <span v-else :class="{ bold: option.selected }">{{ option.name }}</span>
                </template>
            </vue-multi-select>
            <div v-if="errorHas" class="form-input-error">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';

export default {
    name: 'SelectRegions',
    components: {
        vueMultiSelect,
    },
    data() {
        return {
            loading: false,
        };
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        note: {
            type: String,
            required: false,
        },
        placeholder: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        countryId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    computed: {
        errorHas() {
            return this.errors && typeof this.errors[this.field] !== 'undefined' && this.errors[this.field];
        },
        errorMessage() {
            return this.errors[this.field].join('<br/>');
        },
        regions() {
            if (!this.countryId) {
                return [];
            }
            const regions = this.$store.state.regions.list.filter((region) => region !== this.$t('general.form.no_region'));
            return [this.$t('general.form.no_region'), ...regions];
        },
    },
    async mounted() {
        if (this.countryId !== null) {
            await this.$store.dispatch('regions/list', this.countryId);
        }
    },
    watch: {
        async countryId(newCountryId) {
            if (newCountryId === null) {
                this.$store.commit('regions/setList', []);
                return;
            }

            await this.$store.dispatch('regions/list', newCountryId);
        },
    },
    methods: {
        setRegioncodes(newRegioncodes) {
            this.$emit('input', newRegioncodes);
        },
        btnLabel(values) {
            if (!values.length) {
                return this.placeholder;
            }

            return values.join(', ').replace(this.$t('general.form.no_region'), this.$t('general.form.no_region_title'));
        },
    },
};
</script>
